/**
 * Contents of this file were produced with a help of a code generation tool and
 * subsequently reviewed and edited by a human.
 *
 * While some of the code was created by an AI assisted service, manual adjustments
 * have been made to ensure correctness, readability, functionality and compliance
 * to Avalara's coding standards and guidelines. Any future modifications should
 * be approached with caution to avoid overwriting the manual changes.
 *
 * This source code is owned by Avalara Inc. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Proprietary and confidential.
 *
 * For more information, refer to the documentation or contact the development team.
 */

import { useCallback } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { selectSession } from "../app/sessionSlice";
import { getSessionAccessToken } from "../shared/sessionUtility";

/**
 * Custom hook that provides a token provider function for Web Components
 *
 * Creates a memoized function that calls getSessionAccessToken() and changes
 * reference when the session token or active company changes, ensuring
 * Web Component watchers are properly triggered.
 *
 * @returns {Function} tokenProvider - Function that returns a Promise resolving to access token
 */
export const useTokenProvider = () => {
    const session = useSelector(selectSession, shallowEqual);

    return useCallback(() => {
        return getSessionAccessToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session.accessToken, session.activeCompany.id]);
};
